import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuardService } from './auth-guard.service';
import { NotfoundComponent } from './notfound/notfound.component';
import { SalarySlipComponent } from './components/peoplepulse/components/salary-slip/salary-slip.component';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { SuperadminLayoutComponent } from './layouts/superadmin-layout/superadmin-layout.component';
import { environment } from 'environments/environment';
import { LoginDashboardComponent } from './login-dashboard/login-dashboard.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UserListComponent } from './user-list/user-list.component';
import { PermissionComponent } from './components/acl/permission/permission.component';
import { SupplysyncLayoutComponent } from './layouts/supplysync-layout/supplysync-layout.component';
import { StocksphereLayoutComponent } from './layouts/stocksphere-layout/stocksphere-layout.component';
import { PeoplepulseLayoutComponent } from './layouts/peoplepulse-layout/peoplepulse-layout.component';
import { UiShowcaseComponent } from './shared/ui/showcase/ui-showcase/ui-showcase.component';

const redirectPath = environment.hostname !== environment.centralDomain ? 'dashboard' : 'login-dashboard';

const routes: Routes = [
    {
      path: '',
      redirectTo: redirectPath,
      pathMatch: 'full',
    }, 
    // {
    //   path: 'checkpermission',
    //   component: PermissionComponent
    // },
    {
      path: '',
      component: AdminLayoutComponent,
      canActivate:[ ],
      children: [{
        path: '',
        loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule)
      }]
    },
    {
      path: 'notfound',
      component: NotfoundComponent
    },
    {
      path: 'dashboard',
      canActivate:[AuthGuardService],
      component: DashboardComponent
    },
    {
      path: 'userlist/:tenant_id',
      component: UserListComponent
    },
    {
      path: 'ui-showcase',
      canActivate: [AuthGuardService],
      component: UiShowcaseComponent
    },
  ];

  const superAdminRoute: Routes = [
  {
    path: 'superadmin',
    component: SuperadminLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/superadmin-layout/superadmin-layout.module').then(m => m.SuperAdminLayoutModule)
      }
    ]
  },
  {
    path: 'login-dashboard',
    canActivate:[AuthGuardService],
    component: LoginDashboardComponent
  },
  {
    path: 'login',
    canActivate:[AuthGuardService],
    component: LoginComponent
  }
];

const supplySyncRoute: Routes = [
  {
    path: 'supplysync',
    component: SupplysyncLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/supplysync-layout/supplysync-layout.module').then(m => m.SupplysyncLayoutModule)
      }
    ]
  }
];

const stockSphereRoute: Routes = [
  {
    path: 'stocksphere',
    component: StocksphereLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/stocksphere-layout/stocksphere-layout.module').then(m => m.StocksphereLayoutModule)
      }
    ]
  }
];

const peoplePulseRoute: Routes = [
  {
    path: 'peoplepulse',
    component: PeoplepulseLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/peoplepulse-layout/peoplepulse-layout.module').then(m => m.PeoplepulseLayoutModule)
      }
    ]
  }
];


if(environment.hostname === environment.centralDomain){
  routes.push(...superAdminRoute);
}

  // routes.push(...centralHubRoute);

  routes.push(...supplySyncRoute);
  
  routes.push(...stockSphereRoute);
  
  routes.push(...peoplePulseRoute);

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
